import moment, { Moment } from 'moment';
import { FileTypes } from '../../enum/CirgsReportEnums';
import CirgsAbstractFile from './CirgsAbstractFile';

class CirgsReportFile extends CirgsAbstractFile {
  reportId?: string;

  constructor(bucketName: string, fileKey: string, fileName: string,
    fileType: FileTypes, fileApplicationType: string, reportId?: string, id?: string,
    createdAt?: Moment, updatedAt?: Moment) {
    super(bucketName, fileKey, fileName, fileType, fileApplicationType, id, createdAt, updatedAt);
    this.reportId = reportId;
  }

  public objectToBody() {
    return {
      ...super.objectToBody(),
      reportId: this.reportId,
    };
  }

  public static jsonToObject(object: any): CirgsReportFile {
    return new CirgsReportFile(
      object.bucketName,
      object.fileKey,
      object.fileName,
      object.fileType as FileTypes,
      object.fileApplicationType,
      object.reportId,
      object.id,
      moment(object.createdAt),
      moment(object.updatedAt),
    );
  }
}

export default CirgsReportFile;
